import client from '../httpClient';

// 【division002】組織登録
const divisionsResisterApi = (params) => {
  return client.post('/divisions/', JSON.stringify(params), { isShowLoading: true, isShowMessage: '組織を作成しました' });
};

export default divisionsResisterApi;
